import React, { useState, useEffect } from "react";
import {
  Container, Row, Col, Nav, Navbar, Card, Button, Accordion,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../Images/SECTORB12.png";
import FormularioPublicaciones from "./FormularioPublicaciones";
import TablaSolicitudes from "./TablaSolicitudes";
import BuscadorDocumentos from "./BuscadorDocumentos";
import FormularioNotificaciones from "./FormularioNotificaciones";
import Usuarios from "./Usuario";
import GestionExpedientes from "./GestionExpedientes";
import Header from "../Components/Header";
import Footer from "../Components/Footer";

const AdminHome = () => {
  const [activeSection, setActiveSection] = useState("home");
  const [solicitudesNuevas, setSolicitudesNuevas] = useState(0);
  const token = localStorage.getItem("token");

  const fetchContadores = async () => {
    try {
      const res = await fetch("https://sectorb12.info/api/solicitudes/completas", {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        const solicitudes = await res.json();
        const nuevas = solicitudes.filter((s) => !s.Visto).length;
        setSolicitudesNuevas(nuevas);
      }
    } catch (e) {
      console.error("Error al obtener contadores:", e);
    }
  };

  useEffect(() => {
    fetchContadores();
  }, []);

  const marcarVistas = () => {
    fetch("https://sectorb12.info/api/solicitudes/marcar-vistas", {
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
    });
    setSolicitudesNuevas(0);
  };

  const renderNavLinks = () => (
    <>
      {[
        { key: "home",           icon: "bi-house",        label: "Inicio",         badge: 0 },
        { key: "notificaciones", icon: "bi-envelope",     label: "Notificaciones", badge: 0 },
        { key: "solicitudes",    icon: "bi-file-text",    label: "Solicitudes",    badge: solicitudesNuevas },
        { key: "expedientes",    icon: "bi-folder2-open", label: "Expedientes",    badge: 0 },
        { key: "documentos",     icon: "bi-search",       label: "Documentos",     badge: 0 },
        { key: "publicaciones",  icon: "bi-pin",          label: "Publicaciones",  badge: 0 },
        { key: "usuarios",       icon: "bi-person",       label: "Usuarios",       badge: 0 },
      ].map(({ key, icon, label, badge }) => (
        <Nav.Link
          key={key}
          className={`d-flex justify-content-between align-items-center ${activeSection === key ? "active" : ""}`}
          onClick={() => {
            setActiveSection(key);
            if (key === "solicitudes") marcarVistas();
          }}
        >
          <div>
            <i className={`bi ${icon} me-2`}></i> {label}
          </div>
          {badge > 0 && (
            <span className="badge bg-danger rounded-pill ms-2">{badge}</span>
          )}
        </Nav.Link>
      ))}
      <Nav.Link
        className="text-danger"
        onClick={() => {
          localStorage.removeItem("token");
          window.location.href = "/login";
        }}
      >
        <i className="bi bi-box-arrow-right me-2"></i> Cerrar sesión
      </Nav.Link>
    </>
  );

  const renderContent = () => {
    switch (activeSection) {
      case "home":
        return (
          <Row>
            <Header />
            {[
              { key: "notificaciones", icon: "bi-envelope",     title: "Notificaciones", desc: "Cree y envíe notificaciones a los usuarios.",        btn: "Ir a Notificaciones" },
              { key: "solicitudes",    icon: "bi-file-text",    title: "Solicitudes",    desc: "Revise y gestione las solicitudes de los usuarios.",  btn: "Ver Solicitudes" },
              { key: "expedientes",    icon: "bi-folder2-open", title: "Expedientes",    desc: "Gestione los expedientes y sus códigos CVE.",         btn: "Ver Expedientes" },
              { key: "documentos",     icon: "bi-search",       title: "Documentos",     desc: "Busque documentos de un usuario específico.",         btn: "Buscar Documentos" },
              { key: "publicaciones",  icon: "bi-pin",          title: "Publicaciones",  desc: "Cree publicaciones en el tablón de anuncios.",        btn: "Crear Publicación" },
            ].map(({ key, icon, title, desc, btn }) => (
              <Col md={6} key={key}>
                <Card className="mb-4 shadow-sm">
                  <Card.Body>
                    <Card.Title>
                      <i className={`bi ${icon}`}></i> <strong>{title}</strong>
                    </Card.Title>
                    <Card.Text>{desc}</Card.Text>
                    <Button variant="success" onClick={() => {
                      setActiveSection(key);
                      if (key === "solicitudes") marcarVistas();
                    }}>
                      {btn}
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        );

      case "notificaciones":
        return (
          <Row>
            <Header />
            <Card className="p-4 shadow-sm">
              <Card.Body>
                <Card.Title><strong>Formulario de Notificaciones</strong></Card.Title>
                <p>Seleccione un usuario y envíe una notificación personalizada.</p>
                <FormularioNotificaciones />
              </Card.Body>
            </Card>
          </Row>
        );

      case "solicitudes":
        return (
          <Row>
            <Header />
            <Card className="p-4 shadow-sm">
              <Card.Body>
                <Card.Title><strong>Gestión de Solicitudes</strong></Card.Title>
                <TablaSolicitudes />
              </Card.Body>
            </Card>
          </Row>
        );

      case "expedientes":
        return (
          <Row>
            <Header />
            <Card className="p-4 shadow-sm">
              <Card.Body>
                <Card.Title><strong>Gestión de Expedientes</strong></Card.Title>
                <p>Los expedientes se generan automáticamente cuando una solicitud pasa a estado <em>en proceso</em>.</p>
                <GestionExpedientes />
              </Card.Body>
            </Card>
          </Row>
        );

      case "documentos":
        return (
          <Row>
            <Header />
            <Card className="p-4 shadow-sm">
              <Card.Body>
                <Card.Title><strong>Búsqueda de Documentos</strong></Card.Title>
                <p>Seleccione un usuario para buscar sus documentos.</p>
                <BuscadorDocumentos />
              </Card.Body>
            </Card>
          </Row>
        );

      case "publicaciones":
        return (
          <Row>
            <Header />
            <Card className="p-4 shadow-sm">
              <Card.Body>
                <Card.Title><strong>Formulario de Publicaciones</strong></Card.Title>
                <p>Cree un nuevo anuncio para el tablón.</p>
                <FormularioPublicaciones />
              </Card.Body>
            </Card>
          </Row>
        );

      case "usuarios":
        return <Usuarios />;

      default:
        return <h3>Bienvenido al Panel de Administración</h3>;
    }
  };

  return (
    <Container fluid>
      <Row className="min-vh-100 align-items-stretch">
        <Col xs={12} md={3} lg={2} className="sidebar bg-light">
          <Navbar className="flex-column pt-3 d-none d-md-flex">
            <Navbar.Brand className="text-success mb-4">
              <img src={logo} alt="Logo Sector BXII" style={{ width: "140px", objectFit: "contain" }} />
            </Navbar.Brand>
            <Nav className="flex-column w-100">{renderNavLinks()}</Nav>
          </Navbar>

          <Col className="text-success mt-4 mb-2 text-center d-md-none">
            <h5>Panel de Administrador</h5>
          </Col>
          <Accordion className="d-block d-md-none mb-3">
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <strong className="text-success">Menú</strong>
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column">{renderNavLinks()}</Nav>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>

        <Col xs={12} md={9} lg={10}>
          {renderContent()}
        </Col>
        <Footer />
      </Row>
    </Container>
  );
};

export default AdminHome;